import styled from 'styled-components'

type ContainerProps = {
  modalOpen: boolean
}

export const Chart = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: ${props => (props.modalOpen ? '900px' : '450px')};
  height: ${props => (props.modalOpen ? '630px' : '315px')};
  background: white;
  border-radius: 20px;
  box-shadow: 4px 4px 18px -5px rgba(218, 221, 232, 0.8);
  margin-bottom: 1rem;
  grid-column: span 2;
  @media (max-width: 768px) {
    height: 315px;
    width: 300px;
  }
  @media (max-width: 480px) {
    height: 315px;
    width: 100%;
  }
`

export const ChartHeader = styled.div`
  padding: 1rem;
  margin: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f6f6f6;
`

export const ChartBody = styled.div`
  padding: 0.6rem 1.2rem;
  height: 100%;
  display: flex;
  width: 100%;
  flex: 1;
  align-items: center;
`
export const UpdatedLabel = styled.div`
  position: absolute;
  right: 0px;
  font-size: 0.688rem;
  line-height: 0.813em;
  font-weight: 400;
  letter-spacing: 0em;
  color: #718ebf;
  margin: 0;
`
export const ToggleBox = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 2rem;
  align-items: center;
  background: #f0f2f5;
  align-self: center;
  padding: 5px;
  margin-bottom: 1rem;
  border-radius: 5px;
  font-weight: bold;
  font-size: 12px;
`

export const ToggleOption = styled.div<{ selected: boolean }>`
  padding: 5px;
  border-radius: 5px;
  background-color: ${props => (props.selected ? 'white' : '#f0f2f5;')};
  cursor: pointer;
`
